import moment from "moment";
import React from "react";
import { useState } from "react";
import ReactDatePicker from "react-datepicker";
import ReactSelect from "react-select";
import Common from "../../../Common";

class AssignToEdit extends Common {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      options: this.props.colDef.options,
    };
  }

  getValue = () => {
    return this.state.value;
  };

  // any cleanup we need to be done here
  destroy = () => {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
  };

  // if true, then this editor will appear in a popup
  isPopup = () => {
    // and we could leave this method out also, false is the default
    return false;
  };
  componentDidMount() {
    this.setState((state) => {
      return {
        ...state,
        value: this.props?.value?.value || this.props?.value,
      };
    });
    this.focusInput();
  }

  focusInput = () => {
    setTimeout(() => {
      if (this.selectRef) {
        this.selectRef.focus();
      }
    }, 0);
  };
  handleChange = (date) => {
    let convertdate = date ? moment(date).format("YYYY-MM-DD") : "";

    this.setState(
      (state) => {
        return {
          ...state,
          value: convertdate,
        };
      },
      () => {
        this.props.api.stopEditing(); // Stop editing the cell
        this.props.api.applyTransaction({
          update: [{ ...this.props.node.data, column: convertdate }],
        }); // Update the data source
        this.props.api.refreshCells({ rowNodes: [this.props.node] }); // Refresh the grid to reflect the updated data
      }
    );
  };
  render() {
    let newoptions = [];
    if (this.state.options) {
      newoptions = Object.keys(this.state.options).map((item) => ({
        label: this.state.options[item].name,
        value: this.state.options[item].user_uuid,
      }));
    }
    let newvalues = newoptions.filter(
      (item) => item.value === this.state.value
    );
    return (
      <div style={{ width: this.props.colDef.width }}>
        <ReactDatePicker
          open={true}
          selected={this.props.value ? new Date(this.props.value) : new Date()}
          className="rasta-stripes"
          placeholderText="dd-mm-yyyy"
          dateFormat={"dd-MM-yyyy"}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

export default AssignToEdit;
